export const Validators = {
    email: /\S+@\S+\.\S+/,
    phone: /^\d+$/
}